/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SnoozeTodoRequest
 */
export interface SnoozeTodoRequest {
  /**
   *
   * @type {LocalDate}
   * @memberof SnoozeTodoRequest
   */
  snoozedUntil?: LocalDate | null;
}

/**
 * Check if a given object implements the SnoozeTodoRequest interface.
 */
export function instanceOfSnoozeTodoRequest(
  value: object,
): value is SnoozeTodoRequest {
  return true;
}

export function SnoozeTodoRequestFromJSON(json: any): SnoozeTodoRequest {
  return SnoozeTodoRequestFromJSONTyped(json, false);
}

export function SnoozeTodoRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SnoozeTodoRequest {
  if (json == null) {
    return json;
  }
  return {
    snoozedUntil:
      json["snoozedUntil"] == null ? undefined : json["snoozedUntil"],
  };
}

export function SnoozeTodoRequestToJSON(json: any): SnoozeTodoRequest {
  return SnoozeTodoRequestToJSONTyped(json, false);
}

export function SnoozeTodoRequestToJSONTyped(
  value?: SnoozeTodoRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    snoozedUntil: value["snoozedUntil"],
  };
}
